<template>
  <div class="navbar-menu is-active">
    <div class="navbar-start">
      <menu-item
        v-for="(item, index) in menuList"
        :key="index"
        :link="item.link">
          <span class="icon is-small">
            <i v-if="item.text !== 'SDS-Nexus'" :class="item.icon"></i>
            <img v-else src='@/assets/nexus-white.png' alt='' />
          </span>
          <span class="pl-1">{{item.text}}</span>
      </menu-item>
    </div>
  </div>
</template>
<script>
import MenuItem from './MenuItem'
import { TOP_MENU_LIST } from 'common/const.js'

export default {
  name: 'Menu',
  components: { MenuItem },
  data () {
    return {
      menuList: TOP_MENU_LIST
    }
  }
}
</script>
